import type { FormValues } from '../../../../../../common/types';
import { getFormHolidayValuesById } from '../../../../../../common/ui/calendar-utils';
import { validateDate } from './date/utils.tsx';
import { validateName } from './name/utils.tsx';

export const validateHolidayFields = (
	holidayName: string,
	holidayDate: string,
): string | undefined => validateName(holidayName) || validateDate(holidayDate);

export const getValidateFunction =
	(fieldId: number) => (unUsedValue: undefined, formData: FormValues) => {
		const { name, iso8601Date } = getFormHolidayValuesById(fieldId, formData);
		return validateHolidayFields(name, iso8601Date);
	};
